/// <amd-module name="Build/Admin/PoolsList/Stores/SecurityStore" />
import { Store } from "VSS/Reflux/Store";

export interface ISecurityStoreState {
    hasManageAllPermission: boolean;
}

export class SecurityStore extends Store {
    public state: ISecurityStoreState = {
        hasManageAllPermission: false
    };

    constructor() {
        super("SecurityStoreChanged");
    }

    public updateManageAllPermission = (hasManageAllPermission: boolean): void => {
        this.state = {
            ...this.state,
            hasManageAllPermission
        };

        this.emitChanged();
    }
}
